export const ALL_STORES_OPTION_ID = 'all_stores' as const
